module.exports = __webpack_public_path__ + "c717e34b895a64c3877ca510410feaf7.svg";